module.exports = __webpack_public_path__ + "img/Dream-Catcher-new.eecc58c.png";